const meta = {
  'derived-metrics': 'Derived metrics',
  'derived-labels': 'Derived labels',
};

export default meta;
